import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  width: 100%;
  margin: 44px 0;
`

export const Card = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 31px 2rem;
  background-color: ${({ theme }) => theme.colors.white};
  -webkit-box-shadow: 0.5px 2px 4px -1px ${({ theme }) => theme.colors.boxShadow};
  -moz-box-shadow: 0.5px 2px 4px -1px ${({ theme }) => theme.colors.boxShadow};
  box-shadow: 0.5px 2px 4px -1px ${({ theme }) => theme.colors.boxShadow};
  @media screen and (max-width: 1250px) {
    padding: 20px 10px;
    height: unset;
  }
`
export const SectionLine = styled.div`
  width: 41%;
  height: 2px;
  background-color: ${({ theme }) => theme.colors.black};
  position: absolute;
  right: -4rem;
  top: 14px;
  @media screen and (max-width: 1250px) {
    display: none;
  }
`

export const CardTitle = styled.div`
  margin: 0;
  font-family: 'PT Serif Caption', serif;
  font-size: 18px;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 1.25px;
  color: ${({ theme }) => theme.colors.dark};
  @media screen and (max-width: 1250px) {
    text-align: center;
  }
`
export const CardHeader = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-content: center;
  justify-content: center;
  position: relative;
`

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  flex-grow: 1;
  width: 100%;
  @media screen and (max-width: 1250px) {
    flex-direction: column;
  }
`

export const SliderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 60%;
  @media screen and (max-width: 1250px) {
    width: 100%;
    margin-top: 20px;
  }
`

export const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 38%;
  height: 100%;
  padding: 40px 20px 0;
  @media screen and (max-width: 1250px) {
    width: 100%;
  }
`

export const Text = styled.div`
  font-size: 16px;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: 0.09px;
  color: ${({ theme }) => theme.colors.dark};
`

export const TextBox = styled.div`
  margin-top: 12px;
  overflow: hidden;
  position: relative;
`
export const FadeOverlay = styled.div`
  position: absolute;
  height: 150px;
  width: 100%;
  bottom: 0;
  background-image: linear-gradient(to bottom, transparent, #fff9);
`

export const ButtonWithIcon = styled.div`
  margin-top: 40px;
  align-self: center;
  cursor: pointer;
  display: flex;
  justify-content: space-around;
  width: 170px;
  height: 24px;
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  line-height: 1.71;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.greyButton};
  & > .icon {
    color: ${({ theme }) => theme.colors.dark};
  }
`
